export const isBrowser = () => {
  try {
    return window && typeof window != undefined;
  } catch (err) {
    return false;
  }
};

export const isServer = () => !isBrowser();
